<template>
    <!-- A list of names (Configuration's Locations, Departments, Node Types, Teams): type one in and press + or Enter, shown
         as gray chips underneath (shared .tag-chips styles in style.scss). Drag a chip to reorder; the order is kept. -->
    <div class="chip-editor">
        <div class="chip-editor-h">
            <h3>{{ label }}</h3>
            <span class="chip-editor-count">{{ modelValue.length }}</span>
        </div>
        <form class="chip-editor-add" @submit.prevent="add()">
            <input type="text" v-model="input" :placeholder="placeholder" />
            <button class="btn" :aria-label="'Add to ' + label"><svg-icon icon="plus" /></button>
        </form>
        <draggable v-if="modelValue.length" :list="modelValue" class="tag-chips chip-editor-chips" @change="$emit('update:modelValue', [ ...modelValue ])">
            <span v-for="(item, i) in modelValue" :key="item + i" class="tag-chip">
                {{ item }}
                <button type="button" class="tag-chip-x" :aria-label="'Remove ' + item" title="Remove" @click="remove(i)"><svg-icon icon="x" /></button>
            </span>
        </draggable>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { VueDraggableNext } from 'vue-draggable-next';
import SvgIcon from './SvgIcon.vue';

// v-model: the list of names (strings), in order. Adding one that's already there (any capitalization) is ignored.
export default defineComponent({
    name: 'ChipListEditor',
    props: {
        modelValue: { type: Array as () => string[], default: () => [] },
        label: { type: String, default: '' },
        placeholder: { type: String, default: '' }
    },
    emits: [ 'update:modelValue' ],
    components: {
        draggable: VueDraggableNext,
        SvgIcon
    },
    data() {
        return {
            input: ''
        }
    },
    methods: {
        add() {
            const value = this.input.trim();
            this.input = '';
            if(!value || this.modelValue.some((v: string) => v.toLowerCase() == value.toLowerCase())) {
                return;
            }
            this.$emit('update:modelValue', [ ...this.modelValue, value ]);
        },
        remove(i: number) {
            this.$emit('update:modelValue', this.modelValue.filter((_: string, j: number) => j != i));
        }
    }
});
</script>

<style scoped>
/* Header, add row and chips: shared .chip-editor styles in style.scss (Configuration's email recipients use them too) */
.chip-editor-chips .tag-chip { cursor: grab; }
</style>
